export const ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const USERS = `users`;
export const ORGANIZATIONS = `organizations`;
export const DIVISIONS = 'divisions';
export const SCHEDULE_TEMPLATES = 'schedule_templates';
export const SCHEDULES = 'schedules';
export const EXECUTIONS = 'executions';
export const TRIGGERS = 'triggers';
export const SCHEDULE_OPTIONS = 'options';
export const EVENT_TYPES = 'event_types';
export const LOCATION_ALERTS = 'location_alerts';
export const DASHBOARDS = 'dashboards';
export const CHARTS = 'charts';
export const EVENT_CHARTS = 'events';
export const DASHBOARD_EVENTS_TABLES = 'tables';
export const LOCATION_GROUPS = 'location_groups';
export const INVITATIONS = 'invitations';
export const USER_JOBS = 'user_jobs';
export const FAKE_USERS = 'fake_users';
export const PIE_CHARTS = 'pie_charts';
export const COUNT_CHARTS = 'count_charts';
export const COUNTER_CHARTS = 'counter_charts';
export const BAR_CHARTS = 'bar_charts';
// Divisions
export const getRouteToDivision = orgId => `${ORGANIZATIONS}/${orgId}/${DIVISIONS}`;

// Schedule Templates
export const getRouteToScheduleTemplates = (orgId, divId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${SCHEDULE_TEMPLATES}`;

// Schedule
export const getRouteToSchedule = (orgId, divId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${SCHEDULES}`;

// schedule/options
export const getRouteToScheduleOptions = (orgId, divId, scheduleId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${SCHEDULES}/${scheduleId}/${SCHEDULE_OPTIONS}`;

// organizations/{orgId}/divisions/{divId}/location_alerts
export const getRouteToLocationAlerts = (orgId, divId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${LOCATION_ALERTS}`;

/* DASHBAORDS */

// Dashboard/Charts
export const getRouteToEventsCharts = orgId =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${EVENT_CHARTS}/${CHARTS}`;

// Dashboard/Tables
export const getRouteToEventsTables = orgId =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${EVENT_CHARTS}/tables`;

// Dashboards/BOARDS
export const getRouteToNewBoardByOrg = orgId => `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}`;
export const getRouteToNewBoardByDivision = (orgId, divId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}`;

// Dashboards/BOARD_ID/CHARTS
export const getRouteToChartByOrg = (orgId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${boardId}/${CHARTS}`;

export const getRouteToChartByDivision = (orgId, divId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}/${boardId}/${CHARTS}`;

// Dashboards/BOARD_ID/TABLES
export const getRouteToTableByOrg = (orgId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${boardId}/${DASHBOARD_EVENTS_TABLES}`;

export const getRouteToTableByDivision = (orgId, divId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}/${boardId}/${DASHBOARD_EVENTS_TABLES}`;

// Dashboards/BOARD_ID/PIE_CHARTS
export const getRouteToPieChartByOrg = (orgId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${boardId}/${PIE_CHARTS}`;

export const getRouteToPieChartByDivision = (orgId, divId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}/${boardId}/${PIE_CHARTS}`;

// Dashboards/BOARD_ID/COUNT_CHARTS
export const getRouteToCountChartByOrg = (orgId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${boardId}/${COUNT_CHARTS}`;

export const getRouteToCountChartByDivision = (orgId, divId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}/${boardId}/${COUNT_CHARTS}`;

// Dashboards/BOARD_ID/COUNTER_CHARTS
export const getRouteToCounterByOrg = (orgId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${boardId}/${COUNTER_CHARTS}`;

export const getRouteToCounterByDivision = (orgId, divId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}/${boardId}/${COUNTER_CHARTS}`;

// Dashboards/BOARD_ID/BAR_CHARTS
export const getRouteToBarChartByOrg = (orgId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DASHBOARDS}/${boardId}/${BAR_CHARTS}`;

export const getRouteToBarChartByDivision = (orgId, divId, boardId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${DASHBOARDS}/${boardId}/${BAR_CHARTS}`;

/** ** LOCATIONS *** */
export const getRouteLocationGroupByOrg = orgId => `${ORGANIZATIONS}/${orgId}/${LOCATION_GROUPS}`;
export const getRouteLocationGroupGroupsByOrg = (orgId, locationGroupId) =>
  `${ORGANIZATIONS}/${orgId}/${LOCATION_GROUPS}/${locationGroupId}/groups`;

export const getRouteLocationGroupByDivision = (orgId, divId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${LOCATION_GROUPS}`;
export const getRouteLocationGroupGroupsByDivision = (orgId, divId, locationGroupId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${LOCATION_GROUPS}/${locationGroupId}/groups`;

/* ***TRIGGERS*** */

export const getRouteToTriggers = (orgId, divId) =>
  `${ORGANIZATIONS}/${orgId}/${DIVISIONS}/${divId}/${TRIGGERS}`;

/* POSITIONS */
export const getRouteToJob = orgId => `${ORGANIZATIONS}/${orgId}/${USER_JOBS}`;

/* INVITATIONS */
export const getRouteToInvitations = orgId => `${ORGANIZATIONS}/${orgId}/${INVITATIONS}`;
